import Utils from "../utils/utilities"
import { getSingletonInstance } from "../services/singleton-cache"

const HOTLIST_STORAGE_NAME: string = "HOTLIST_STORE"
const hotlist: any = {
    bgName: '',
    bgId: undefined,
    bgLists: [],
    get name() { return this.bgName },
    set name(value: string) {
        this.bgName = value

        if (Utils.isDefined(this.id) && Utils.isNotEmpty(this.lists)) {
            const thisList: any = this.lists.filter(entry => entry.id === this.id)

            if (Utils.isNotEmpty(thisList)) {
                thisList[0].name = value
                this.lists = thisList[0]
                document.querySelector('title').innerHTML = `${value} Hotlist`
            }
        }

        addToLocalStore()
    },
    get id() { return this.bgId },
    set id(value: string) {
        this.bgId = value
        addToLocalStore()
    },
    get lists() {
        return this.bgLists
    },
    set lists(value: any) {
        if (Utils.isDefined(value) && Utils.isDefined(value.length)) {
            this.bgLists = value
            addToLocalStore()
        } else {
            if (Utils.isDefined(value.id)) {
                this.bgLists = this.bgLists.filter(entry => entry.id !== value.id)
            }

            this.bgLists.unshift(value)
            addToLocalStore()
        }
    }
}

function addToLocalStore(): void {
    localStorage.setItem(HOTLIST_STORAGE_NAME, JSON.stringify({
        name: hotlist.name,
        id: hotlist.id,
        lists: hotlist.lists
    }))
}

export default function HotlistStorage(target: any, key: string): any {
    const singletonTarget: any = getSingletonInstance(target)

    if (Utils.isDefined(localStorage.getItem(HOTLIST_STORAGE_NAME))) {
        const hotlistStore: any = localStorage.getItem(HOTLIST_STORAGE_NAME)

        if (hotlistStore != '') {
            const hotlistFromLocalStore = JSON.parse(hotlistStore)
            hotlist.name = hotlistFromLocalStore.name
            hotlist.id = hotlistFromLocalStore.id
            hotlist.lists = hotlistFromLocalStore.lists
        }
    }

    singletonTarget[key] = hotlist
}